import { UiActions } from './reducer';

export const setBrowser = (isBrowser: boolean) => {
  return {
    type: UiActions.SET_IS_BROWSER,
    isBrowser,
  };
};
